import { sileo } from "sileo";

interface ToastOptions {
  autoClose?: number;
  hideProgressBar?: boolean;
  type?: "success" | "error" | "warning" | "info" | "default";
  closeOnClick?: boolean;
  pauseOnHover?: boolean;
  draggable?: boolean;
  progress?: undefined;
  theme?: "dark" | "light";
  transition?: unknown;
}

// No-op: sileo is global, no initialization needed
 
export const initializeToastService = (_toastMethods: unknown) => {};

export const toast = (message: string, options?: ToastOptions) => {
  const { type = "default", autoClose } = options || {};
  const opts = { title: message, duration: autoClose };

  switch (type) {
    case "success":
      return sileo.success(opts);
    case "error":
      return sileo.error(opts);
    case "warning":
      return sileo.warning(opts);
    case "info":
      return sileo.info(opts);
    default:
      return sileo.info(opts);
  }
};

export const toastSuccess = (message: string, options?: ToastOptions) => {
  return sileo.success({ title: message, duration: options?.autoClose });
};

export const toastError = (message: string, options?: ToastOptions) => {
  return sileo.error({ title: message, duration: options?.autoClose });
};

export const toastWarning = (message: string, options?: ToastOptions) => {
  return sileo.warning({ title: message, duration: options?.autoClose });
};

export const toastInfo = (message: string, options?: ToastOptions) => {
  return sileo.info({ title: message, duration: options?.autoClose });
};
